module.exports = __webpack_public_path__ + "img/perks_B Priority Access 1.d1cbbcb7.jpg";